(()=>{
 const selector='img[data-tz-product-hover]';
 function check(image){
  if(image.getAttribute('src')&&image.complete&&image.naturalWidth>0)image.setAttribute('data-tz-hover-ready','');
  else image.removeAttribute('data-tz-hover-ready');
 }
 function load(card){
  if(!card)return;
  card.querySelectorAll(selector).forEach(image=>{
   const source=image.getAttribute('data-tz-hover-src');
   if(source&&!image.getAttribute('src')){
    image.setAttribute('loading','eager');
    image.setAttribute('fetchpriority','low');
    image.setAttribute('src',source);
   }
   check(image);
  });
 }
 function init(root=document){root.querySelectorAll(selector).forEach(check);}
 document.addEventListener('pointerover',event=>{
  if(window.matchMedia('(hover:hover) and (pointer:fine)').matches)load(event.target.closest?.('.tz-card,.tz-card-wrap'));
 });
 document.addEventListener('focusin',event=>load(event.target.closest?.('.tz-card,.tz-card-wrap')));
 document.addEventListener('load',event=>{if(event.target.matches?.(selector))check(event.target);},true);
 document.addEventListener('error',event=>{if(event.target.matches?.(selector))event.target.removeAttribute('data-tz-hover-ready');},true);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();

